import { render, staticRenderFns } from "./DashboardFodlers.vue?vue&type=template&id=4615efe6"
import script from "./DashboardFodlers.vue?vue&type=script&lang=js"
export * from "./DashboardFodlers.vue?vue&type=script&lang=js"
import style0 from "./DashboardFodlers.vue?vue&type=style&index=0&id=4615efe6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports